// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"2eb2b641df124cc866f5","293":"6723d36022fab55e51a2","522":"fc5d010a3a06f687197d"}[chunkId] + ".js";
};